export default function CTASection() {
  return (
    <section className="relative w-full">
      <div className="grid grid-cols-1 lg:grid-cols-2">
        <div className="relative h-[350px] md:h-[500px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Overhead%20fashion%20flat%20lay%20with%20diverse%20clothing%20items%20sneakers%20leather%20accessories%20and%20fabric%20swatches%20arranged%20in%20artistic%20chaotic-but-organized%20composition%20on%20warm%20linen%20textile%20background%2C%20soft%20overhead%20studio%20lighting%20creating%20gentle%20shadows%2C%20earthy%20terracotta%20sand%20and%20cream%20color%20palette%2C%20editorial%20fashion%20catalog%20photography%20with%20organic%20flowing%20arrangement%20and%20rich%20textural%20detail&width=960&height=1080&seq=cta-left-v2-2026&orientation=portrait"
            alt="Hipobuy Spreadsheet product collection showcase"
            className="w-full h-full object-cover"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-black/15"></div>
          <div className="absolute bottom-8 left-8">
            <span className="text-xs font-medium text-background-50/70 whitespace-nowrap">Curated Collections</span>
            <h3 className="font-heading text-3xl md:text-4xl font-bold text-background-50 mt-1">
              Explore Hipobuy<br />Spreadsheet
            </h3>
          </div>
        </div>

        <div className="flex flex-col items-center justify-center px-6 md:px-16 py-16 md:py-0 bg-background-50">
          <div className="max-w-md text-center">
            <span className="inline-flex items-center gap-2 px-3 py-1 bg-primary-100 text-primary-700 text-xs font-semibold rounded-full mb-6 whitespace-nowrap">
              <i className="ri-rocket-line"></i>
              Ready to Start?
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-5 leading-tight">
              Discover Products<br />Faster &amp; Smarter
            </h2>
            <p className="text-base text-foreground-500 mb-8 leading-relaxed">
              Jump into the world of organized product discovery. Access curated spreadsheets, 
              compare options, and make informed shopping decisions — all in one place.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 text-base font-semibold text-background-50 bg-foreground-950 hover:bg-foreground-800 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              buy it now
              <i className="ri-arrow-right-up-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}